// extracted by mini-css-extract-plugin
export default {"FlexContainer":"form-patial_FlexContainer__CPEIA","col":"form-patial_col__QDuxk"};